import { Controller } from "@hotwired/stimulus";

var HubAdminFormController = class extends Controller {
  connect() {
    this.disableNameFields();
    this.lookup();
  }

  disconnect() {
    clearTimeout(this.lookupTimeout);
  }

  lookup() {
    clearTimeout(this.lookupTimeout);
    this.lookupTimeout = setTimeout(() => this.fetchUser(), 250);
  }

  fetchUser() {
    var email = this.emailTarget.value.trim();

    if (!email || !this.emailTarget.validity.valid) {
      this.clearNameFields();
      this.disableNameFields();
      return;
    }

    var url = new URL(this.lookupUrlValue, window.location.origin);
    url.searchParams.set("email", email);

    fetch(url.toString(), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((data) => {
        if (this.emailTarget.value.trim().toLowerCase() !== email.toLowerCase())
          return;

        if (data.found) {
          this.firstNameTarget.value = data.first_name || "";
          this.lastNameTarget.value = data.last_name || "";
          this.disableNameFields();
        } else {
          this.clearNameFields();
          this.enableNameFields();
        }
      })
      .catch(() => {
        this.enableNameFields();
      });
  }

  clearNameFields() {
    this.firstNameTarget.value = "";
    this.lastNameTarget.value = "";
  }

  disableNameFields() {
    this.firstNameTarget.disabled = true;
    this.lastNameTarget.disabled = true;
  }

  enableNameFields() {
    this.firstNameTarget.disabled = false;
    this.lastNameTarget.disabled = false;
  }
};

HubAdminFormController.targets = ["email", "firstName", "lastName"];
HubAdminFormController.values = { lookupUrl: String };

export default HubAdminFormController;
